module.exports = __webpack_public_path__ + "static/media/Maf_30Julio.87154f96.jpg";